import { IBuildings } from '@llws/lift-entity-interfaces';
import { ISidebarHeader, ISidebarHeaderConfig } from '@/shared/interfaces/sidebar-header-config';
import { propertySingle } from '@/router/properties';
import websites from '@/shared/services/websites';
import { IApiResponse } from '@/shared';
import properties from '@/shared/services/properties';
import vm from '@/main';

export const sidebarHeaderConfigs = [
  {
    routeStartsWith: '/properties/:propertyId/unit-types/:unitId',
    routeParamName: ':propertyId',
    setHeaderCallback: async (routeParamNameValue: string | number): Promise<ISidebarHeader> => {
      const result: IApiResponse<IBuildings, any> = await properties.getUnitDataForSubheader(routeParamNameValue);

      return {
        title: `${result.data!.buildingName} (${result.data!.suiteTypes![0]!.typeName})`,
        subtitle: `${result.data!.streetNumber} ${result.data!.streetName}`,
        imageUrl: result.data?.buildingsHasPhotos && result.data.buildingsHasPhotos.length
          ? result.data.buildingsHasPhotos[0]?.listingPhoto?.image : null,
        data: result.data,
        icon: 'fal fa-house',
        redirectRoute: propertySingle,
        target: `/properties/${result.data?.id}/details`,
      } as ISidebarHeader;
    },
  },
  {
    routeStartsWith: '/properties/:propertyId',
    routeParamName: ':propertyId',
    setHeaderCallback: async (routeParamNameValue: string | number): Promise<ISidebarHeader> => {
      const result: IApiResponse<IBuildings, any> = await properties.getForSubheader(routeParamNameValue);
      const unitId = vm()?.$route.params || null;

      return {
        title: result.data!.buildingName,
        subtitle: `${result.data!.streetNumber} ${result.data!.streetName}`,
        imageUrl: result.data?.buildingsHasPhotos && result.data.buildingsHasPhotos.length
          ? result.data.buildingsHasPhotos[0]?.listingPhoto?.image : null,
        data: result.data,
        icon: 'fal fa-house',
        redirectRoute: propertySingle,
      } as ISidebarHeader;
    },
  },
  {
    routeStartsWith: '/websites/:websiteId',
    routeParamName: ':websiteId',
    setHeaderCallback: async (routeParamNameValue: string | number): Promise<ISidebarHeader> => {
      const result: IApiResponse<any, any> = await websites.getForSubheader(routeParamNameValue);
      return {
        title: result.data!.name,
        subtitle: result.data!.siteUrl ? 'Visit Website' : '',
        subtitleUrl: result.data!.siteUrl,
        data: result.data,
        icon: 'fal fa-globe',
      } as ISidebarHeader;
    },
  },
] as ISidebarHeaderConfig[];
